import TrainingsHero from "../components/Training/TrainingsHero";
import TrainingPrograms from "../components/Training/TrainingPrograms";
import TrainingFormats from "../components/Training/TrainingFormats";
import TrainingRegister from "../components/Training/TrainingRegister";
import InViewFade from "../components/Generic/InViewFade";

const Training = () => {
  return (
    <div className="training-page bg-title">
      <InViewFade direction="down">
        <TrainingsHero />
      </InViewFade>

      <InViewFade direction="left">
        <TrainingFormats />
      </InViewFade>

      <InViewFade direction="right">
        <TrainingPrograms />
      </InViewFade>

      <InViewFade direction="up">
        <TrainingRegister />
      </InViewFade>
    </div>
  );
};

export default Training;
